import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["usageTracker", "componentName", "stopPropagation", "onClick", "screen", "subscreen", "extraTrackingData", "upgradeSource"];
import { useUserCanEditBilling } from '../../hooks/useUserCanEditBilling';
import { ComponentViewTracker } from './ComponentViewTracker';
import { trackClick } from './trackingFunctions';
import { jsx as _jsx } from "react/jsx-runtime";
export function withClickTracking(WrappedComponent) {
  return function ClickTrackedComponent(_ref) {
    let {
        usageTracker,
        componentName,
        stopPropagation = false,
        onClick,
        screen,
        subscreen,
        extraTrackingData
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const userCanEditBilling = useUserCanEditBilling();
    const handleClick = event => {
      if (stopPropagation) {
        event.stopPropagation();
      }
      if (usageTracker) {
        trackClick(usageTracker, Object.assign({
          component: componentName,
          screen,
          subscreen,
          isBillingAdmin: userCanEditBilling
        }, extraTrackingData));
      }
      if (onClick) {
        onClick(event);
      }
    };
    return /*#__PURE__*/_jsx(ComponentViewTracker, {
      usageTracker: usageTracker,
      componentName: componentName,
      screen: screen,
      subscreen: subscreen,
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        onClick: handleClick
      }, rest))
    });
  };
}